<template>
  <div>
    <div class="development">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="module">
          <div>
            <div class="title" v-jump="'/product/product3'">三维融合渲染平台</div>
            <div
              class="p"
            >GIS二三维数据渲染支持、BIM数据渲染支持、GIS+BIM场景融合渲染、海量三维数据极速渲染、地理坐标&BIM坐标转换、GIS+BIM空间分析、三维特效模块组、可视化交互式开发工具。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product3'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product1'">二三维GIS地理信息平台</div>
            <div
              class="p"
            >实现二维地图和三维地图的可视化渲染；二三维地图点线面标绘；地图事件响应机制和接口；图层叠加控制、地图热力图、专题图等；电子围栏功能；路线导航功能。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product1'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product2'">2.5D-GIS平台</div>
            <div
              class="p"
            >实现2.5D地图渲染发布，基于2.5D地图的浏览、漫游、缩放、刷新等基本功能；实现基于2.5D地图的点线面标绘、热力图、专题图等功能，2.5D地图与VR全景的结合等。提供基于JavaScript+H5跨平台的简洁开发...</div>
            <div class="more" v-jump="'/product/product2'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product4'">VR全景三维可视化平台</div>
            <div class="p">实现三维全景VR沉浸式漫游功能，基于三维全景图片的深度映射建模工具，创新性的三维建模+全景VR技术融合。提供免费的VR全景和三维建模PASS平台...</div>
            <div class="more" v-jump="'/product/product4'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product5'">室内地图可视化平台</div>
            <div
              class="p"
            >室内地图在线可视化编辑绘制、室内地图二三维渲染、室内地图图层管理、室内地图查询检索、室内地图图形标绘、室内地图操作事件自定义、室内地图路线导航。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product5'">了解更多</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-development">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div>
            <div class="title" v-jump="'/product/product3'">三维融合渲染平台</div>
            <div
              class="p"
            >GIS二三维数据渲染支持、BIM数据渲染支持、GIS+BIM场景融合渲染、海量三维数据极速渲染、地理坐标&BIM坐标转换、GIS+BIM空间分析、三维特效模块组、可视化交互式开发工具。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product3'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product1'">二三维GIS地理信息平台</div>
            <div
              class="p"
            >实现二维地图和三维地图的可视化渲染；二三维地图点线面标绘；地图事件响应机制和接口；图层叠加控制、地图热力图、专题图等；电子围栏功能；路线导航功能。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product1'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product2'">2.5D-GIS平台</div>
            <div
              class="p"
            >实现2.5D地图渲染发布，基于2.5D地图的浏览、漫游、缩放、刷新等基本功能；实现基于2.5D地图的点线面标绘、热力图、专题图等功能，2.5D地图与VR全景的结合等。提供基于JavaScript+H5跨平台的简洁开发...</div>
            <div class="more" v-jump="'/product/product2'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product4'">VR全景三维可视化平台</div>
            <div class="p">实现三维全景VR沉浸式漫游功能，基于三维全景图片的深度映射建模工具，创新性的三维建模+全景VR技术融合。提供免费的VR全景和三维建模PASS平台...</div>
            <div class="more" v-jump="'/product/product4'">了解更多</div>
          </div>
          <div>
            <div class="title" v-jump="'/product/product5'">室内地图可视化平台</div>
            <div
              class="p"
            >室内地图在线可视化编辑绘制、室内地图二三维渲染、室内地图图层管理、室内地图查询检索、室内地图图形标绘、室内地图操作事件自定义、室内地图路线导航。提供基于JavaScript+H5跨平台的简洁开发API...</div>
            <div class="more" v-jump="'/product/product5'">了解更多</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Development",
  metaInfo: {
    title: "开发中心_二三维GIS地图、BIM可视化、VR全景、室内地图平台用户开发服务_ZTMap-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "GIS开发API,地图开发API,BIM可视化开发API,ZTMap开发中心,ZTMap用户手册,ZTMap接口文档,ZTMap开发示例DEMO"
      },
      {
        name: "description",
        content:
          "提供ZTMapGIS、ZTMap3D、ZTMapVR、ZTMapInidoor系列三维可视化平台开发服务,包括开发API、接口文档、开发示例、DEMO演示等。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "开发中心",
        p:
          "提供ZTMapGIS、ZTMap3D、ZTMapVR、ZTMapInidoor系列三维可视化平台开发服务，包括开发API、接口文档、开发示例、DEMO演示等。"
      }
    };
  },
  methods: {},
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/development/banner.jpg");
}
.development {
  .list {
    padding: 100px 0 150px 0;
    .module {
      font-size: 0;
      > div {
        width: 583px;
        height: 383px;
        background: #ccc;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 20px;
        margin-right: 20px;
        padding: 0 36px;
        box-sizing: border-box;
        position: relative;
        &:nth-of-type(1) {
          background: url("../assets/images/development/dev1.jpg") no-repeat
            center center / 100%;
        }
        &:nth-of-type(2) {
          background: url("../assets/images/development/dev2.jpg") no-repeat
            center center / 100%;
          margin-right: 0px;
        }
        &:nth-of-type(3) {
          background: url("../assets/images/development/dev3.jpg") no-repeat
            center center / 100%;
          width: 382px;
        }
        &:nth-of-type(4) {
          background: url("../assets/images/development/dev4.jpg") no-repeat
            center center / 100%;
          width: 382px;
        }
        &:nth-of-type(5) {
          background: url("../assets/images/development/dev5.jpg") no-repeat
            center center / 100%;
          margin-bottom: 0;
          margin-right: 0px;
          width: 382px;
        }
        .title {
          font-size: 30px;
          color: rgba(255, 255, 255, 1);
          line-height: 53px;
          margin: 60px 0 0 0;
          cursor: pointer;
        }
        .p {
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
          margin-top: 20px;
        }
        .more {
          width: 156px;
          height: 48px;
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 1);
          font-size: 18px;
          color: rgba(255, 255, 255, 1);
          line-height: 48px;
          text-align: center;
          margin: 394px 0 0 40px;
          cursor: pointer;
          position: absolute;
          bottom: 40px;
          left: 0px;
        }
      }
    }
  }
}
.mobile-development {
  display: none;
  width: 100%;
  flex-direction: column;
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/development/banner.jpg");
    background-position: 80%;
    background-size: cover;
    height: 28rem;
  }
  .list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 2rem 3rem 2rem;
    >div {
      width: 33.5rem;
      height: 22rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 3rem;
      font-family: 'Normal';
      color: #fff;
      &:nth-of-type(1) {
        background: url("../assets/images/development/dev1.jpg") no-repeat
          center center / 100%;
      }
      &:nth-of-type(2) {
        background: url("../assets/images/development/dev2.jpg") no-repeat
          center center / 100%;
      }
      &:nth-of-type(3) {
        background: url("../assets/images/development/dev3.jpg") no-repeat
          center center / 100%;
      }
      &:nth-of-type(4) {
        background: url("../assets/images/development/dev4.jpg") no-repeat
          center center / 100%;
      }
      &:nth-of-type(5) {
        background: url("../assets/images/development/dev5.jpg") no-repeat
          center center / 100%;
      }
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        
      }
      .p {
        width: 23.5rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.5rem;
        margin-top: 2rem;
      }
      .more {
        width: 11.5rem;
        height: 3.2rem;
        line-height: 3.2rem;
        background: #3C80E8;
        margin-top: 2rem;
        text-align: center;
        color: #fff;
        font-size: 1.2rem;
        border: none;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: 1024px) {
  .development {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-development { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/development.vue